/**
 * @name: currency.js
 * @description: 格式化数字为会计常用格式,如：2 => 2.00
 * @author: 温永江
 * @create: 2020/07/22 14:19:39
 * @update: 2020/07/22 14:19:39
 */

export default (value, n = 2) => {
  let v = value - 0;
  if (value === '' || value === undefined || value === null) {
    return '';
  } if (v === 0) {
    return '0.00';
  } if (isNaN(v)) {
    return value;
  }
  value = Number(v).toFixed(8) - 0;
  const splitV = (`${value}`).split('.');
  const int = splitV[0].replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
  if (splitV[1]) {
    return `${int}.${splitV[1]}`;
  }
  return (
    `${int
    }.${
      Array.apply(null, { length: n - 0 })
        .map((t) => '0')
        .join('')}`
  );
};
